var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { BTab, BTabs } from "bootstrap-vue";
import { computed, ref } from "vue";
import { editFormDataToPayload, editTemplateForm } from "@/components/ConfigTemplates/formUtil";
import { useInstanceAndTemplate } from "./instance";
import { useInstanceRouting } from "./routing";
import { update } from "./services";
import EditSecrets from "./EditSecrets.vue";
import InstanceForm from "@/components/ConfigTemplates/InstanceForm.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditInstance',
    props: {
        instanceId: null
    },
    setup(__props) {
        const props = __props;
        const { instance, template } = useInstanceAndTemplate(ref(props.instanceId));
        const inputs = computed(() => {
            template.value;
            instance.value;
            if (template.value && instance.value) {
                return editTemplateForm(template.value, "storage location", instance.value);
            }
            return undefined;
        });
        const title = computed(() => { var _a; return `Edit File Source ${(_a = instance.value) === null || _a === void 0 ? void 0 : _a.name} Settings`; });
        const hasSecrets = computed(() => { var _a, _b; return ((_a = instance.value) === null || _a === void 0 ? void 0 : _a.secrets) && ((_b = instance.value) === null || _b === void 0 ? void 0 : _b.secrets.length) > 0; });
        const submitTitle = "Update Settings";
        const loadingMessage = "Loading file source template and instance information";
        function onSubmit(formData) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                if (template.value) {
                    const payload = editFormDataToPayload(template.value, formData);
                    const args = { user_file_source_id: String((_a = instance === null || instance === void 0 ? void 0 : instance.value) === null || _a === void 0 ? void 0 : _a.uuid) };
                    const { data: fileSource } = yield update(Object.assign(Object.assign({}, args), payload));
                    yield onUpdate(fileSource);
                }
            });
        }
        const { goToIndex } = useInstanceRouting();
        function onUpdate(instance) {
            return __awaiter(this, void 0, void 0, function* () {
                const message = `Updated file source ${instance.name}`;
                goToIndex({ message });
            });
        }
        return { __sfc: true, props, instance, template, inputs, title, hasSecrets, submitTitle, loadingMessage, onSubmit, goToIndex, onUpdate, BTab, BTabs, EditSecrets, InstanceForm };
    }
});
